import { getCategories } from '@/backend/casino/get-categories/server-side-rendered';
import CasinoCategoriesClient from './CasinoCategoriesClient/CasinoCategoriesClient';

const CasinoCategories = async () => {
	const categories = await getCategories();

	if (!categories) {
		return null;
	}

	return (
		<>
			<CasinoCategoriesClient categories={categories} />
		</>
	);
};

export default CasinoCategories;
